import React from 'react';
import {
  default as ConfirmationModal,
  Props as ConfirmationModalProps,
} from '../../Popup/ConfirmationModal';
import { useTranslation } from 'react-i18next';
import { PremiumTrash, Lock, Unlock } from '@wix/da-ds/pkg/Icons/Confirmations';
import { ConfirmationPopupType } from '../types';

export interface Props {
  confirmationType: ConfirmationPopupType;
  isOpen?: boolean;
  onCancel?(): void;
  onConfirm?(): void;
}

export const CommissionConfirmation: React.FC<Props> = ({
  isOpen = false,
  confirmationType,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  const content = {
    remove: {
      title: t('commission.delete.confirmHeader'),
      text: t('commission.delete.confirmText'),
      confirmBtnLabel: t('commission.delete.confirmButton'),
      confirmBtnType: 'danger' as ConfirmationModalProps['confirmBtnType'],
      icon: <PremiumTrash />,
    },
    enable: {
      title: t('commission.enable.confirmHeader'),
      text: t('commission.enable.confirmText'),
      confirmBtnLabel: t('commission.enable.confirmButton'),
      icon: <Unlock />,
    },
    enableAll: {
      title: t('commission.enableAll.confirmHeader'),
      text: t('commission.enableAll.confirmText'),
      confirmBtnLabel: t('commission.enableAll.confirmButton'),
      icon: <Unlock />,
    },
    disable: {
      title: t('commission.disable.confirmHeader'),
      text: t('commission.disable.confirmText'),
      confirmBtnLabel: t('commission.disable.confirmButton'),
      confirmBtnType: 'danger' as ConfirmationModalProps['confirmBtnType'],
      icon: <Lock />,
    },
    disableAll: {
      title: t('commission.disableAll.confirmHeader'),
      text: t('commission.disableAll.confirmText'),
      confirmBtnLabel: t('commission.disableAll.confirmButton'),
      confirmBtnType: 'danger' as ConfirmationModalProps['confirmBtnType'],
      icon: <Lock />,
    },
    disableLast: {
      title: t('commission.disableLast.confirmHeader'),
      text: t('commission.disableLast.confirmText'),
      confirmBtnLabel: t('commission.disableLast.confirmButton'),
      confirmBtnType: 'danger' as ConfirmationModalProps['confirmBtnType'],
      icon: <Lock />,
    },
    discardChanges: {
      title: t('commission.confirm.discardChanges.header'),
      text: t('commission.confirm.discardChanges.text'),
      confirmBtnLabel: t('popup.discardChanges'),
      confirmBtnType: 'danger' as ConfirmationModalProps['confirmBtnType'],
      icon: <PremiumTrash />,
    },
    leaveCreating: {
      title: t('commission.confirm.discard.header'),
      text: t('commission.confirm.discard.text'),
      confirmBtnLabel: t('popup.discard'),
      confirmBtnType: 'danger' as ConfirmationModalProps['confirmBtnType'],
      icon: <PremiumTrash />,
    },
  };

  return (
    <ConfirmationModal
      {...content[confirmationType]}
      onCancel={onCancel}
      onConfirm={onConfirm}
      isOpen={isOpen}
    />
  );
};
CommissionConfirmation.displayName = 'CommissionConfirmation';

export default CommissionConfirmation;
